"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Modal extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: this.props.visible || false
    };
    this.hideModal = this.hideModal.bind(this);
  }
  componentDidUpdate() {
    if (this.props.visible === false && this.state.visible === true || this.props.visible === true && this.state.visible === false) this.toggleVisible(this.props.visible);
  }
  hideModal() {
    if (this.props.closeCallBack) this.props.closeCallBack();
  }
  toggleVisible(visible) {
    this.setState({
      visible
    });
  }
  render() {
    const {
      id,
      heading,
      lead,
      content
    } = this.props;
    const {
      visible
    } = this.state;
    const style = {
      display: visible ? 'block' : 'none'
    };
    const modalClass = (0, _classnames.default)({
      'modal': true,
      'fade': true,
      'in': visible
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      role: "dialog",
      "aria-labelledby": id + 'Heading',
      className: modalClass,
      id: id,
      style: style
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-dialog"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-content"
    }, (heading || lead) && /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-header"
    }, /*#__PURE__*/_react.default.createElement("button", {
      ref: c => this._modalCloseButton = c,
      className: "close",
      "data-hxtrack-name": "close_modal",
      "data-dismiss": "modal",
      type: "button",
      "aria-label": "Close",
      onClick: this.hideModal
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")), heading && /*#__PURE__*/_react.default.createElement("h4", {
      className: "modal-title",
      id: id + 'Heading'
    }, heading), lead && /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, lead)), content && typeof content === 'object' && /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-body"
    }, content), content && typeof content !== 'object' && /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-body",
      dangerouslySetInnerHTML: {
        __html: content
      }
    }))));
  }
}
Modal.propTypes = {
  id: _propTypes.string.isRequired,
  heading: _propTypes.string,
  lead: _propTypes.string,
  content: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]),
  visible: _propTypes.bool,
  closeCallBack: _propTypes.func
};
Modal.defaultProps = {
  visible: false
};
var _default = exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/modal.js
// module id = 755
// module chunks = 119